module.exports = __webpack_public_path__ + "img/right_md_2.73cba7f7.jpg";